// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-modal {
  width: var(--quiz-modal-width-tablet) !important;
}
@media (min-width: 1200px) {
  .quiz-modal {
    width: var(--quiz-modal-width-desktop) !important;
  }
}
.quiz-modal__success {
  padding: 4rem;
  font-weight: 500;
  line-height: 27.6px;
  font-size: var(--default-size-body);
}`, "",{"version":3,"sources":["webpack://./src/components/modals/QuizModal/QuizModal.scss"],"names":[],"mappings":"AAEA;EACI,gDAAA;AADJ;AAGI;EAHJ;IAIQ,iDAAA;EAAN;AACF;AAEI;EACI,aAAA;EACA,gBAAA;EAEA,mBAAA;EACA,mCAAA;AADR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
